import {StyleSheet} from 'react-native';
import {FONTS} from '../../../utils/Constants';

// Theme-aware styles factory (docs/DARK-MODE.md).
const makeStyles = colors =>
  StyleSheet.create({
    container: {
      flexDirection: 'row',
      alignItems: 'center',
    },
    titleStyle: {
      fontFamily: FONTS.regularFont,
      fontSize: 14,
      color: colors.textPrimary,
      marginLeft: 11,
    },
  });

export default makeStyles;
